import api from "./api";
const base = "/api/periodic-tasks/";
export const listPeriodicTasks = () => api.get(base);
export const periodicTaskOptions = () => api.get(`${base}options/`);
export const previewPeriodicTask = (schedule) =>
  api.post(`${base}preview/`, { schedule });
export const createPeriodicTask = (data) => api.post(base, data);
export const updatePeriodicTask = (id, data) =>
  api.patch(`${base}${id}/`, data);
export const runPeriodicTask = (id) => api.post(`${base}${id}/run/`, {});
